import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "popup-close",
  "use": "popup-close-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\" id=\"popup-close\"><path fill-rule=\"evenodd\" d=\"m6.314 5.607 4.596 4.596a.5.5 0 0 1-.707.707L5.607 6.314 1.01 10.91a.5.5 0 0 1-.707-.707L4.9 5.607.303 1.01A.5.5 0 1 1 1.01.303L5.607 4.9 10.203.303a.5.5 0 1 1 .707.707z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol